import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    location: '',
    slotMonth: new Date(),
    isLoading: false,
    allEvents: [],
    allSlots: [],
};


// fetch the all roles data
export const fetchAllSlots = createAsyncThunk(
    'roles/fetchAllSlots',
    async (params, { rejectWithValue }) => {
        try {
            const response = await api.get('/slot-module/list/calendar', { params: params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Create slots
export const createSlots = createAsyncThunk(
    'roles/createSlots',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post('/slot-module/create', data);
            dispatch(clearAllEvents())
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

// Delete slots
export const deleteSlot = createAsyncThunk(
    'roles/deleteSlot',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/slot-module/${id}/delete`,);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

const slotManagementSlice = createSlice({
    name: 'slotManagement',
    initialState,
    reducers: {
        setLocation(state, action) {
            state.location = action.payload
        },
        changeSlotMonth(state, action) {
            state.slotMonth = action.payload
        },
        addMoreEvents(state, action) {
            state.allSlots = action.payload
        },
        clearAllEvents(state) {
            state.allSlots = []
        },
    },
    extraReducers: (builder) => {
        /// handle fetch all role
        builder
            .addCase(fetchAllSlots.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllSlots.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allEvents = action.payload.data
            })
            .addCase(fetchAllSlots.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle fetch all role
        builder
            .addCase(createSlots.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createSlots.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(createSlots.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle fetch all role
        builder
            .addCase(deleteSlot.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteSlot.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteSlot.rejected, (state) => {
                state.isLoading = false;
            });
    },
}); 

export const { setLocation, changeSlotMonth, addMoreEvents, clearAllEvents, } = slotManagementSlice.actions

export const selectSlotsLoading = (state) => state.slotManagement?.isLoading;
export const selectSlotLocation = (state) => state.slotManagement?.location;
export const selectAllEvents = (state) => state.slotManagement?.allEvents;

export const selectAllSlots = (state) => state.slotManagement?.allSlots;
export const selectSlotMonth = (state) => state.slotManagement?.slotMonth;







export default slotManagementSlice.reducer;
